import BigPicture from 'bigpicture'
import sidePanel from 'side-panel-menu-thing'
import Intro from '../components/intro.svelte'
import HeroBackground from '../components/hero-background.svelte'
import { getDataAttributes } from '../util/util'

let { body } = document

export default {
	init() {
		let target = document.getElementById('intro')

		new HeroBackground({
			target: document.getElementById('hero'),
		})

		new Intro({
			target,
			props: getDataAttributes(target),
		})
	},
	finalize() {
		const forwardPanel = new sidePanel({
			target: document.body,
			props: {
				target: document.body,
				content: document.getElementById('bio_rick'),
				width: 680,
				duration: 580,
			},
		})

		// illustrations lightbox
		let illustrations = body.querySelectorAll('#illustrations img')
		for (let i = 0; i < illustrations.length; i++) {
			let img = illustrations[i]
			img.addEventListener('click', (e) => {
				BigPicture({
					el: e.target,
					gallery: illustrations,
				})
			})
		}

		// read forward button
		let forwardBtn = document.getElementById('forward_btn')
		forwardBtn.addEventListener('click', forwardPanel.show)
	},
}
